<template>
  <bottom-bar-layout class="page-training-task-finish"
                     v-if="work.id > 0"
                     show-bar
                     :bar-height="170"
                     :shadow="false"
                     bar-background="transparent"
                     :is-show-guide-popup="false"
  >
    <div class="share-hint">
      <span>长按保存图片 分享朋友圈</span>
      <ym-icon class="icon-arrow-down"
                name="arrow-down-fill"
      />
    </div>

    <div class="img-container"
         v-if="work.src !== ''"
    >
      <ym-img class="img"
              :src="work.src"
              alt="分享图"
      />
    </div>

    <template #tabbar>
    <div class="footer">
      <ym-button class="training-submit-btn training-submit-btn-primary-plain training-calendar-btn"
                   size="large"
                   @click="handleBackToCalendar"
        >
          打卡日历
        </ym-button>
        <ym-button class="training-submit-btn training-submit-btn-light js-share-btn"
                   :data-clipboard-text="$wechat.getWechatMenuShareAppLink()"
                   size="large"
                   @click="handleShare"
        >
          分享给好友
        </ym-button>
      </div>
    </template>

    <share-mask :show.sync="showShareMask"
                :share-path="$wechat.getWechatMenuShareAppLink()"
                message="请复制下方链接，前往粘贴给好友"
    />
  </bottom-bar-layout>
</template>

<script>
  import ClipboardJS from 'clipboard';
  import { Button } from '@ymba/ym-ui';
  import BottomBarLayout from '@/layout/BottomBarLayout';
  import { isTrainingTaskFinish, getTrainingWorkNotify } from '@/services/training';
  import { isAppWebView, isWeiXinBrowser } from '@/utils';
  import { commonLog } from '@/services/app';
  import ShareMask from '@/components/ShareMask';
  import { locationToAppWithRoute } from '@/utils/app-route';

  export default {
    name: 'PageTrainingWorkNotify',
    metaInfo: {
      title: '完成打卡',
    },
    components: {
      BottomBarLayout,
      ShareMask,
      'ym-button': Button,
    },
    data() {
      return {
        work: {
          id: 0,
          src: '',
        },
        training: {
          id: 0,
        },
        showShareMask: false,
        generatedResult: false,
      };
    },
    computed: {
      trainingTitle() {
        return this.training.title.replace(' ', '<br/>');
      },
    },
    methods: {
      async fetchData() {
        const { id } = this.$route.params;
        const data = await getTrainingWorkNotify(id);

        this.work = data.work;
        this.training = data.training;
      },
      handleBackToCalendar() {
        const { training } = this;
        const { id } = training;
        const route = { name: 'TrainingDetail', params: { id } };
        this.$router.push(route);
      },
      handleShare() {
        if (isWeiXinBrowser()) {
          this.showShareMask = true;
          return;
        }
        if (isAppWebView()) {
          const wechatShare = this.$wechat.getWechatMenuShareAppParams();
          locationToAppWithRoute({
            name: 'AppBaseShare',
            params: { ...wechatShare },
          }, 1);
          return;
        }
        const clipboard = new ClipboardJS('.js-share-btn');
        clipboard.on('success', () => {
          this.showShareMask = true;
        });
        clipboard.on('error', (e) => {
          commonLog('clipboardError', e);
        });
      },
    },
    created() {
      this.fetchData();
    },
    async beforeRouteLeave(to, from, next) {
      // 处理返回
      const { name, params } = to;
      // 不返回至任务详情，直接通过
      if (name !== 'TaskDetail') {
        next();
        return;
      }
      const data = await isTrainingTaskFinish(params.id);
      // 返回的任务详情如果已完成，跳转至作品详情
      if (data.render.isFinish) {
        const route = { name: 'TrainingWorkDetail', params: { id: data.work.id }, replace: true };
        next(route);
        return;
      }
      next();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';
  @import '~@/assets/styles/mixins.less';

  .page-training-task-finish {
    height: 100%;
    padding: @size-small 0;
    .training-gradient-primary(-45deg);
    background-image: url('@{assets-img}training/work_finish_bg.png');
    background-size: 750px;
    overflow: scroll;
    box-sizing: border-box;
  }

  .share-hint {
    font-size: @font-size-medium;
    color: @color-white;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    z-index: @z-index-medium;
    span {
      margin-bottom: @size-extra-small;
    }
    .icon-arrow-down {
      font-size: 40px;
      color: #ccf5f3;
    }
  }

  .img-container {
    width: 690px;
    margin: 0 auto;
    border-radius: @border-radius-medium;
    box-shadow: @training-finish-card-shadow;
    .img {
      width: 100%;
      border-radius: @border-radius-medium;
    }
  }

  .footer {
    flex: 1;
    display: flex;
    justify-content: space-between;
    padding: @size-base;
    .training-submit-btn {
      &:not(:last-child) {
        margin-right: @size-base;
      }
    }
  }

  .training-calendar-btn {
    border: @border-width-base @border-style-base @training-primary-color-lighter;
    color: @training-primary-color-lighter;
    background: #00afda;
  }

</style>
